import { SchoolView } from "../firestore/Types/SchoolSchema";

export function SchoolTag( { school, imageUrl = "" }: { school?: SchoolView, imageUrl?: string }) {
    if (school) {
        return (
            <div className="flex flex-row mx-auto max-w-[400px]">
                {imageUrl === "" && <div className="rounded-lg w-[100px] min-w-35 m-4 aspect-square" />}
                {imageUrl !== "" && <img src={imageUrl} alt="schoolimg" className="rounded-lg w-[100px] min-w-35 mr-4 aspect-square" />}
                <div className="flex flex-col grow gap-2 p-2 text-slate-700">
                    <h2 className="text-base text-bold text-sky-500">{school.Name}</h2>
                    <div className="text-sm">{school.Address}</div>
                    <div className="text-sm">{school.FullName}</div>
                </div>
            </div>
        );
    }
    return (
        <></>
        //<div className="flex flex-row">
        //    <img src={`${process.env.PUBLIC_URL}/UnknownSchool.png`} alt="profile" className="rounded-lg w-[15%] min-w-35 m-4 aspect-square" />
        //    <div className="flex flex-col grow gap-2">
        //        <h2 className="text-base text-bold text-sky-500">Not Listed</h2>
        //    </div>
        //</div>
    )
}